export enum AreaType {
  Urban = 0,
  Regional = 1
}

export enum JobType {
  Mixed = 0,
  Underground = 1,
  Overhead = 2,
  Drafting = 3,
  Detailing = 4,
  ProjectManagement = 5,
  Design = 6,
  UndergroundLocating = 7,
  Admin = 8
}

export enum JobItemType {
  None = 0,
  Underground = 1,
  Overhead = 2,
  Drafting = 4,
  Detailing = 8,
  ProjectManagement = 16,
  Design = 32,
  UndergroundLocating = 64,
  Admin = 128
}

export enum Status {
  Pending = 0,
  Scheduled = 1,
  Actioned = 2,
  Invoiced = 3,
  Completed = 4,
  Cancelled = 5,
  InvoicedNoCharge = 6
}

export enum DocumentType {
  Supplied = 0,
  Internal = 1,
  Sent = 2
}

export enum ActivityInvoiceType {
  Normal = 0,
  NoInvoice = 1,
  ExternalInvoice = 2
}

export class EnumModel {
  public name: string;
  public value: number;

  constructor(name: string, value: number) {
    this.name = name;
    this.value = value;
  }
}

export class EnumModelGeneric<T> {
  public name: string;
  public value: T;

  constructor(name: string, value: T) {
    this.name = name;
    this.value = value;
  }
}

export const DocumentTypeEnums: EnumModel[] = [
  new EnumModel('Supplied', 0),
  new EnumModel('Internal', 1),
  new EnumModel('Sent', 2)
];

export const ActvityInvoiceTypeEnums: EnumModel[] = [
  new EnumModel('Normal', 0),
  new EnumModel('No Invoice', 1),
  new EnumModel('Externally Created Invoice', 2)
];

export const StatusEnums: EnumModel[] = [
  new EnumModel('Pending', 0),
  new EnumModel('Scheduled', 1),
  new EnumModel('Actioned', 2),
  new EnumModel('Invoiced', 3),
  new EnumModel('Invoiced No Charge', 6),
  new EnumModel('Completed', 4),
  new EnumModel('Cancelled', 5)
];

export const JobItemTypeEnums: EnumModel[] = [
  new EnumModel('Underground Audit', JobItemType.Underground),
  new EnumModel('Overhead', JobItemType.Overhead),
  new EnumModel('Drafting', JobItemType.Drafting),
  new EnumModel('Detailing', JobItemType.Detailing),
  new EnumModel('Project Management', JobItemType.ProjectManagement),
  new EnumModel('Design', JobItemType.Design),
  new EnumModel('Underground Locating', JobItemType.UndergroundLocating),
  new EnumModel('Administration', JobItemType.Admin)
];

export const JobItemTypeEnumsGeneric: Array<EnumModelGeneric<JobItemType>> = [
  new EnumModelGeneric<JobItemType>('Underground Audit', JobItemType.Underground),
  new EnumModelGeneric<JobItemType>('Overhead', JobItemType.Overhead),
  new EnumModelGeneric<JobItemType>('Drafting', JobItemType.Drafting),
  new EnumModelGeneric<JobItemType>('Detailing', JobItemType.Detailing),
  new EnumModelGeneric<JobItemType>('Project Management', JobItemType.ProjectManagement),
  new EnumModelGeneric<JobItemType>('Design', JobItemType.Design),
  new EnumModelGeneric<JobItemType>('Underground Locating', JobItemType.UndergroundLocating),
  new EnumModelGeneric<JobItemType>('Administration', JobItemType.Admin)
];

export const JobTypeEnums: EnumModel[] = [
  new EnumModel('Mixed', JobType.Mixed),
  new EnumModel('Underground Audit', JobType.Underground),
  new EnumModel('Overhead', JobType.Overhead),
  new EnumModel('Drafting', JobType.Drafting),
  new EnumModel('Detailing', JobType.Detailing),
  new EnumModel('Project Management', JobType.ProjectManagement),
  new EnumModel('Design', JobType.Design),
  new EnumModel('Underground Locating', JobType.UndergroundLocating),
  new EnumModel('Administration', JobType.Admin)
];

export const AreaTypeEnums: EnumModel[] = [new EnumModel('Urban', 0), new EnumModel('Regional', 1)];


